import { GIT_REV } from "@/constants/env";

export const version = () => {
  console.log(
    `
%c
██████╗ ██╗   ██╗███████╗██████╗      ██████╗ ██████╗ ██████╗ ██████╗ 
██╔══██╗██║   ██║██╔════╝██╔══██╗    ██╔════╝██╔═══██╗██╔══██╗██╔══██╗
██║  ██║██║   ██║█████╗  ██████╔╝    ██║     ██║   ██║██████╔╝██████╔╝
██║  ██║╚██╗ ██╔╝██╔══╝  ██╔══██╗    ██║     ██║   ██║██╔══██╗██╔═══╝ 
██████╔╝ ╚████╔╝ ███████╗██║  ██║    ╚██████╗╚██████╔╝██║  ██║██║
╚═════╝   ╚═══╝  ╚══════╝╚═╝  ╚═╝     ╚═════╝ ╚═════╝ ╚═╝  ╚═╝╚═╝  
                                                                      
%cVERSION ${GIT_REV}
    `,
    "color:#0081ea",
    "color:black"
  );
};
